<p-card header="{{ developer().firstName }} {{ developer().lastName }}">
  <ng-template class="team-card-header" pTemplate="header">
    <div class="profile-picture-container">
      <img class="profile-picture" src="assets/dev-images/{{ developer().imageName }}" />
    </div>
  </ng-template>
  <ng-template pTemplate="subtitle">
    <div class="subtitle-container">
      @for (infoLine of developer().degreeInfo; track infoLine) {
        <span>{{ infoLine }}</span>
      }
    </div>
  </ng-template>
  <div class="card-content-container"><b>Hobbies:</b> {{ developer().hobby }}</div>
  <ng-template pTemplate="footer">
    <div class="team-card-footer">
      <a
        pButton
        class="filled-btn"
        [label]="developer().hasLinkedIn ? 'Add Me on LinkedIn' : 'Calvin Directory'"
        target="_blank"
        [href]="developer().contactLink"
      ></a>
    </div>
  </ng-template>
</p-card>
